import { Event } from "@mcleod/components";
import { AddMenuBranch } from "../AddMenuBranch";
import { MenuActionSlideout } from "../MenuActionSlideout";
import { MenuEditorTreeNode } from "../MenuEditorTreeNode";
import { EditMenuItemResult } from "../MenuItemEditor";
import { MenuAction } from "./MenuAction";

export class MenuActionAddBranch extends MenuAction {

    override async internalExecute(): Promise<boolean> {
        const parentNodes = this.getNodesMatchingThisMenuGroup();
        const result = await this.showAddBranch(parentNodes);
        if (result?.menuItem == null) {
            return false;
        }
        for (const parentNode of parentNodes) {
            const newBranch = result.menuItem.createCopy();
            this.menuItemToSelect ??= newBranch;
            const parentBranch = parentNode.menuItem;
            parentBranch.addChild(newBranch);
        }
        return true;
    }

    override validate(): boolean {
        return this.node?.hasChildren() === true;
    }

    private async showAddBranch(parentNodes: MenuEditorTreeNode[]): Promise<EditMenuItemResult> {
        let layout: AddMenuBranch;
        const result = await MenuActionSlideout.showAddBranchSlideout({
            title: this.getActionTitle("Add Branch"),
            layoutLoadListeners: [
                (event: Event) => {
                    layout = event.target as AddMenuBranch;
                    layout.configureForAddMode(parentNodes);
                }
            ]
        });
        return result ? layout.getNewBranchMenuItem() : null;
    }
}
